import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from 'react-bootstrap';
import { useSelector } from "react-redux";
import Swal from 'sweetalert2';
import axios from 'axios';
import PayUForm from '../../Utils/PayUForm';
import { toast } from 'react-toastify';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function DishHome({ operatorCode }) {
  const currentUser = useSelector((state) => state.data);
  const [packageData, setPackageData] = useState(false);
  const [payuData, setPayuData] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const { Subscriber, Amount, wallet_type } = e.target;
    try {
      if (Amount) {
        let amountData = (Amount.value).split("|");
        let sendData = {
          service: "dishHome",
          service_provider: operatorCode,
          msisdn: Subscriber.value,
          amount: parseInt(amountData[1]),
          plan: amountData[0],
          ref_stan: packageData?.refStan,
          bill_number: packageData?.billNumber,
          session_id: packageData?.session_id,
          wallet_type: wallet_type?.value,
        };
        const response = await axios.post("/recharge/services/pay", sendData);
        const { status, message, hashData, rechage_response: rd } = response.data;
        if (status) {
          if (hashData) {
            const payuData = {
              hash: hashData.hash,
              txnid: hashData.txId,
              amount: hashData.amount,
              firstname: currentUser.name,
              email: currentUser.email,
            };
            setPayuData(payuData);
          }
          else {
            let rechrgeMessage = "<table align='center'><tr><td>Subscriber</td><td>" + rd.subscriber_number + "</td></tr><tr><td>Amount</td><td>" + rd.amount + "</td></tr><tr><td>Receipt</td><td>" + rd.reciept + "</td></tr><tr><td colspan='100%'>" + rd.message + "</td></tr></table>"
            Swal.fire({
              title: 'Recharge Successful!',
              html: rechrgeMessage,
              icon: 'success',
              //confirmButtonText: 'OK'
            });
            setPackageData(false);
          }
        }
        else {
          toast(message);
        }
      }
      else {
        const response = await axios.post("/prabhuRecharge/getDishHomePackage", { msisdn: Subscriber.value, service_provider: operatorCode });
        const { status, data } = response.data;
        if (status) {
          setPackageData(response.data);
        }
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };

  return (
    <>
      {
        payuData && (
          <PayUForm formData={payuData} autoSubmit={true} />
        )
      }
      <Form onSubmit={handleSubmit}>
        <div className="row">
          <>
            <div class="col-lg-12 col-md-12">
              <label>Subscriber Number/Bill Number</label>
              <input type="text" class="form-control" name="Subscriber" required />
            </div>
            {
              packageData ? (
                <>
                  <div class="col-lg-12 col-md-12">
                    <label>Amount</label>
                    <select class="form-control" name="Amount" required>
                      <option value="">--Select--</option>
                      {(packageData.packages).map((p, index) => (
                        <option value={p.id + '|' + p.amount}>
                          {p.val}
                        </option>
                      ))}
                      {/* {((packageData.packages).split("|")).map((p, index) => (
                        <option value={p}>
                          {p}
                        </option>
                      ))} */}
                    </select>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <label>Wallet Type</label>
                    <select class="form-control" name="wallet_type" required>
                      <option value="">--Select--</option>
                      <option value="wallet">Wallet</option>
                      <option value="remitance">Remitance</option>
                      <option value="payu">Online payment(Payu)</option>
                    </select>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <input type="submit" className="search-btn btn btn-primary" value="Pay" />
                  </div>
                </>
              ) : (
                <>
                  <div class="col-lg-12 col-md-12">
                    <input type="submit" className="search-btn btn btn-primary" value="Get Package" />
                  </div>
                </>
              )
            }
          </>
        </div>
      </Form>
    </>
  );
}

export default DishHome;
